// ──────────────────────────────────────────────────────────────────────
// useSidebarCounts — D63 Issue 5.
//
// Returns live per-nav-item count badges. Polls every 15s + refreshes on
// any of the well-known custom events broadcast across the app. Tabs
// share the same in-memory state via window-level custom events.
// ──────────────────────────────────────────────────────────────────────
import useLiveData from './useLiveData';
import { sidebarAPI } from './api';

export const DEFAULT_SIDEBAR_COUNTS = {
  team_chat: 0,
  deadline_calendar: 0,
  availability_calendar: 0,
  team_eod_report: 0,
  my_eod: 0,
  my_clients: 0,
  tasks: 0,
  reviews: 0,
  contracts: 0,
  notifications: 0,
  idea_bank: 0,
};

const SIDEBAR_EVENTS = [
  'stellar-chat-changed',
  'stellar-task-changed',
  'stellar-eod-changed',
  'stellar-leave-changed',
  'stellar-content-posts-changed',
  'stellar-content-comments-changed',
  'stellar-notification-changed',
  'stellar-contracts-changed',
  // D65 P0-3 — mark-viewed click refresh.
  'stellar-sidebar-counts-refresh',
];

export default function useSidebarCounts(workspaceId) {
  const { data, refetch, lastSynced } = useLiveData(
    async () => {
      if (!workspaceId) return DEFAULT_SIDEBAR_COUNTS;
      try {
        const r = await sidebarAPI.counts(workspaceId);
        return { ...DEFAULT_SIDEBAR_COUNTS, ...(r.data || {}) };
      } catch {
        return DEFAULT_SIDEBAR_COUNTS;
      }
    },
    [workspaceId],
    { intervalMs: 15_000, refetchOnFocus: true, events: SIDEBAR_EVENTS, enabled: !!workspaceId, initialData: DEFAULT_SIDEBAR_COUNTS },
  );
  return { counts: data || DEFAULT_SIDEBAR_COUNTS, refetch, lastSynced };
}
